import { ThemeProvider, createTheme } from "@mui/material/styles";
import DesktopProductFinder from "./DesktopProductFinder";
import useWindowSize from "./hooks/useWindowSize";
import MobileProductFinder from "./MobileProductFinder";
import { categoryList } from "./constants";

// Augment the palette to include a lime color
declare module "@mui/material/styles" {
	interface Palette {
		lime: Palette["primary"];
	}

	interface PaletteOptions {
		lime?: PaletteOptions["primary"];
	}
}

// Update the Button's color options to include a lime option
declare module "@mui/material/Button" {
	interface ButtonPropsColorOverrides {
		lime: true;
	}
}

let theme = createTheme({
	palette: {
		primary: {
			main: "#003087",
			light: "#3f51b5",
			dark: "#000a48",
			contrastText: "#ffffff",
		},
		secondary: {
			main: "#41B6E6",
			light: "#EEF7FD",
			dark: "#008ba3",
			contrastText: "#000000",
		},
	},
});

theme = createTheme(theme, {
	palette: {
		lime: theme.palette.augmentColor({
			color: { main: "#84BD00", light: "#F9FCF2" },
			name: "lime",
		}),
	},
});

export default function App() {
	const { width } = useWindowSize();
	return (
		<ThemeProvider theme={theme}>
			{width < 768 ? (
				<MobileProductFinder list={categoryList} />
			) : (
				<DesktopProductFinder tabList={categoryList} />
			)}
		</ThemeProvider>
	);
}
